import React from 'react';
import { I18n } from 'react-redux-i18n';

export enum NavigationItemKey {
  GENERAL = 'general',
  DOCUMENTS = 'documents',
  KEY_INDICATORS = 'key-indicators'
  // LOCATION = 'location'
}

type StoreNavigationTabProps = {
  displayDocumentsTab: boolean;
  activeTab: NavigationItemKey;
  setActiveTab: (tab: NavigationItemKey) => void;
};

export const StoreNavigationTab = ({
  displayDocumentsTab,
  activeTab,
  setActiveTab
}: StoreNavigationTabProps) => {
  const navigationItems = [
    {
      key: NavigationItemKey.GENERAL,
      label: I18n.t('storePopup.tabs.general')
    },
    {
      key: NavigationItemKey.DOCUMENTS,
      label: I18n.t('storePopup.tabs.documents')
    }
    // {
    //   key: NavigationItemKey.LOCATION,
    //   label: I18n.t('storePopup.tabs.location')
    // }
  ];

  const filteredNavigationItems = displayDocumentsTab
    ? navigationItems
    : navigationItems.filter(
        (item) => item.key !== NavigationItemKey.DOCUMENTS
      );

  return (
    <div className="tabs-container">
      {filteredNavigationItems.map((item) => {
        const isActive = activeTab === item.key;
        return (
          <button
            key={item.key}
            className={`tab ${isActive ? 'active' : ''}`}
            onClick={() => setActiveTab(item.key)}
          >
            {item.label}
          </button>
        );
      })}
    </div>
  );
};
